import { apiFetch } from '../lib/apiFetch';

export interface PosterVenue {
  venueKey: string;
  venueName: string;
  city: string | null;
  state: string | null;
}

export async function fetchPosterVenues(): Promise<PosterVenue[]> {
  const res = await apiFetch('/api/v1/posters/venues');
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Failed to load venues' }));
    throw new Error((err as { error?: string }).error || 'Failed to load venues');
  }
  return res.json();
}

export async function downloadVenuePoster(
  venueKey: string,
  options: { bookingUrl?: string; daysAhead?: number } = {}
): Promise<void> {
  const params = new URLSearchParams();
  if (options.bookingUrl) params.set('bookingUrl', options.bookingUrl);
  if (options.daysAhead) params.set('daysAhead', String(options.daysAhead));

  const query = params.toString() ? `?${params.toString()}` : '';
  const url = `/api/v1/posters/venue/${venueKey}${query}`;

  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Failed to generate poster' }));
    throw new Error((err as { error?: string }).error || 'Failed to generate poster');
  }

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = 'bonsaibar-poster.pdf';
  a.click();
  URL.revokeObjectURL(objectUrl);
}
